module.exports = __webpack_public_path__ + "media/images/social-icons/facebook-white-d4c61e2df0fdb2c236f0dea1497fcad8.svg";